require('./openYoungFiscalDataStep2.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const {
    CONFIRMATION_SCRIPT_AGREEMENT,
    CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY,
    ConfirmationScript,
} = require('components/contactCenter/confirmScript/confirmationScript');

// @constants
const { getTranslatedCountry } = require('constants/countries');
const { OPEN_YOUNG_UPDATE_PROFILE } = require('constants/operationTypes');
const TAXING_REASON = require('constants/taxingReason');

class OpenYoungFiscalDataStep2 extends React.Component {

    render() {
        const {immOpenYoungTaxData} = this.props;
        const operative = formatText('operatives-openYoungBeneficiaryFiscalDataEdit');
        let content;
        const listCountriesAdditionalTaxing = immOpenYoungTaxData.get('byId');
        if (!listCountriesAdditionalTaxing || (listCountriesAdditionalTaxing.size === 0 )) {
            content = <FormattedText className="open-young-fiscal-data-view__text-additional-tributation" value="profile-taxInformation_noAdditionalTributation"/>;
        } else {
            content = [];
            listCountriesAdditionalTaxing.forEach((immCountry, index) => {
                const country = getTranslatedCountry(immCountry.getIn(['country', 'value']));
                const taxingReason = TAXING_REASON[immCountry.getIn(['reason', 'value'])];
                const tin = immCountry.getIn(['tin', 'value']);
                content.push(
                    <div className="open-young-fiscal-data-view__text-additional-tributation" key={index}>
                        {`${country}, ${taxingReason}. TIN: ${tin}`}
                    </div>
                );
            });
        }

        return (
            <article className="open-young-fiscal-data-view">
                <FormattedText
                    className="open-young-fiscal-data-step-2__title"
                    value="openYoungFiscalData-openYoungFiscalData_confirmationTitle"
                />
                <ContactCenterRender>
                    <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY} />
                </ContactCenterRender>
                <FormattedText
                    className="open-young-fiscal-data-step-2__subtitle"
                    value="openYoungFiscalData-openYoungFiscalData_confirmationSubtitle"
                />
                <OKInformativeList columns={1}>
                    <OKInformativeListItem
                        title={formatText('openYoungFiscalData-openYoungFiscalData_fiscalData')}
                        onlyChildren
                    >
                        {content}
                    </OKInformativeListItem>
                </OKInformativeList>
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
                <SignaturePattern
                    operationType={OPEN_YOUNG_UPDATE_PROFILE}
                    operationParams={{}}
                />
            </article>
        );
    }
}

OpenYoungFiscalDataStep2.propTypes = {
    immOpenYoungTaxData: PropTypes.object.isRequired,
};

module.exports = OpenYoungFiscalDataStep2;
